import { TextField } from '@mui/material'

import { formatCode } from 'components/common/CodeBlock'

export const ResponseBodyField: React.FC<{
  responseBody: string | null | undefined
}> = ({ responseBody }) => {
  if (!responseBody) return null

  return (
    <TextField
      disabled
      fullWidth
      multiline
      data-testid="test-status-check-integration-response-body"
      InputProps={{ sx: { fontFamily: 'Monaco' } }}
      label="Response Body"
      maxRows={8}
      sx={{ fontFamily: 'Sohne Mono' }}
      value={formatCode(null, responseBody)}
    />
  )
}
